<script setup lang="ts" generic="TOption, TValue">
import { ListboxGroupLabel, ListboxItem } from "reka-ui";
import type { ListOption, OptionItem } from "../listbox/listbox";

const props = defineProps<{ option: ListOption<TOption, TValue> }>();
const emit = defineEmits<{
	select: [option: OptionItem<TOption, TValue>];
}>();

defineSlots<{
	label?(slotProps: { label: string }): any;
	option?(slotsProps: { option: TOption }): any;
}>();
</script>

<template>
	<ListboxItem
		v-if="props.option.type === 'item'"
		class="command-item w-full"
		:value="props.option.value as any"
		:disabled="props.option.disabled"
		@select="emit('select', props.option)"
	>
		<slot name="option" :option="props.option.option">
			{{ props.option.label }}
		</slot>
	</ListboxItem>

	<ListboxGroupLabel
		v-else-if="props.option.type === 'label'"
		class="text-muted-content px-2 py-1.5 text-sm font-medium"
	>
		<slot name="label" :label="props.option.label">
			{{ props.option.label }}
		</slot>
	</ListboxGroupLabel>
</template>
